export class CdStaticRoles {

    /// <summary>
    /// Разрешено подписывать без усиления
    /// </summary>
    static CdSimpleSignAllowed = "ace772e6-6646-4a66-bec1-9bc1693c61d4";

    
    /// <summary>
    /// Администратор доверенностей
    /// </summary>
    static PoAAdminRoleID = "91707309-ab6c-4b6c-96f1-df16bea8d8e9";
    
    /// <summary>
    /// Просмотр xml в МЧД
    /// </summary>
    static CanWatchXmlInMachineReadablePoA = "c3cb692e-a4af-421b-9a51-252448e77d51";

    /// <summary>
    /// Администраторы ИРД.
    /// </summary>
    static IrdAdministrators = 'dd4fe9fd-d6f0-4a1e-8746-c17303aab803';

    // Управление Достроя И Восстановления
    static УправлениеДострояИВосстановления  = 'df7f50ab-e7bd-4f45-a469-0d7224d9ee58';
  }